import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import DashboardWidgets from "../views/Dashboard/DashboardWidgets.vue";
import DashboardTable from "../views/Dashboard/DashboardTable.vue";

Vue.use(VueRouter);

/**
 * @type {import("vue-router").RouteConfig[]}
 */
const routes = [
  {
    path: "/",
    component: Dashboard,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: DashboardWidgets,
        props: true
      },
      {
        path: "table",
        name: "DashboardTable",
        component: DashboardTable,
        props: true
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
